import styled, { keyframes, css } from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';
import Copy from '@Utils/shared/components/Icons-v3/Copy';
import DangerousInnerHTML from '@Utils/shared/components/DangerousInnerHTML-v3';
import Button from '@Utils/shared/components/Button-v3';

const showCopyElement = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const WrapperNickname = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0 0 6px 6px;
  padding: 0 25px;

  @media ${mediaQueries.mobile} {
    padding: 0 15px;
  }
`;

export const NicknameInfo = styled.div<{ isTouchDevice?: boolean }>`
  display: flex;
  padding-bottom: 25px;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding-bottom: 5px;
  }

  ${(props) =>
    props.isTouchDevice &&
    css`
      @media (max-width: 1366px) and (min-width: 1024px) {
        flex-direction: column;
        padding-bottom: 5px;
      }
    `}
`;

export const Nickname = styled.div<{ isTouchDevice?: boolean }>`
  position: relative;
  margin-right: 45px;
  flex-grow: 1;

  &::after {
    content: '';
    position: absolute;
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPk5pY2tuYW1lIEZpZWxkPC90aXRsZT4KICAgIDxkZWZzPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iNTAlIiB5MT0iMCUiIHgyPSI1MCUiIHkyPSIxMDAlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGQTUyMDAiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZBM0YwMCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJWLTMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0wLDEgTDMuODU5MjY0OTcsMSBDNS4xOTY2Nzc3MiwxIDYuNDQ1NjAzMDMsMS42Njg0MDQ1NCA3LjE4NzQ2NjE0LDIuNzgxMTk5MjIgTDI1LjI2MDM5OTcsMjkuODkwNTk5NiBDMjUuNzA4MjY1NiwzMC41NjIzOTg0IDI1LjcwODI2NTYsMzEuNDM3NjAxNiAyNS4yNjAzOTk3LDMyLjEwOTQwMDQgTDcuMTg3NDY2MTQsNTkuMjE4ODAwOCBDNi40NDU2MDMwMyw2MC4zMzE1OTU1IDUuMTk2Njc3NzIsNjEgMy44NTkyNjQ5Nyw2MSBMMCw2MSBMMCw2MSIgaWQ9Ik5pY2tuYW1lLUZpZWxkIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0iIzE5MUIxRiI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=')
      no-repeat;
    width: 27px;
    height: 62px;
    right: -25px;
    top: 0;
  }

  @media (max-width: 1024px) {
    margin-top: 15px;
    margin-right: 0;

    &::after {
      display: none;
    }
  }

  ${(props) =>
    props.isTouchDevice &&
    css`
      @media (max-width: 1366px) and (min-width: 1024px) {
        margin-top: 15px;
        margin-right: 0;

        &::after {
          display: none;
        }
      }
    `}
`;

export const Info = styled(DangerousInnerHTML)`
  padding: 10px 0 15px;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
  color: #fff;

  & a {
    color: var(--color-blue-dark);
    text-decoration: none;

    &:hover {
      color: #fcfcfc;
      text-decoration: none;
    }
  }
`;

const commonInput = css`
  line-height: 26px;
  padding-left: 10px;
  border-radius: 6px;
`;

export const Input = styled.input<{ isTouchDevice?: boolean }>`
  font-family: 'Roboto Condensed', sans-serif;
  width: 100%;
  font-size: 24px;
  line-height: 38px;
  color: var(--bg-white);
  padding: 10px 45px 10px 70px;
  border-radius: 6px 0 0 6px;
  border: solid 2px transparent;
  background: linear-gradient(#191b1f, #191b1f) padding-box,
    /*this is your grey background*/ linear-gradient(to bottom, #fa5200, #fa3f00) border-box;

  @media ${mediaQueries.mobile} {
    font-size: 16px;
    padding: 5px 45px 5px 70px;
  }

  @media (max-width: 1024px) {
    ${commonInput}
  }

  ${(props) =>
    props.isTouchDevice &&
    css`
      @media (max-width: 1366px) and (min-width: 1024px) {
        ${commonInput}
      }
    `}
`;

export const Avatar = styled.img`
  position: absolute;
  left: 5px;
  top: 6px;
  background: #ccc;
  width: 50px;
  height: 50px;
  border-radius: 2px;
  box-shadow: 0 1px 20px -6px rgba(0, 0, 0, 0.5);
  object-fit: cover;
`;

export const PlayNowButton = styled(Button)`
  padding: 0 10px;
  min-width: fit-content;
`;

export const Popover = styled.div`
  display: none;
  transform: translate(-50%, 0px);
  left: 50%;
  bottom: 150%;
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #424249;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #f3f3f3;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    border: 11px solid transparent;
    border-top: 6px solid #f3f3f3;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0px);
  }
`;

export const CopyButton = styled.button<{ isTouchDevice: boolean }>`
  display: flex;
  background: transparent;
  border: none;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 21px;

  @media (max-width: 1024px) {
    top: 16px;
  }

  @media ${mediaQueries.mobile} {
    top: 12px;
  }

  ${(props) =>
    props.isTouchDevice &&
    css`
      @media (max-width: 1366px) and (min-width: 1024px) {
        top: 16px;
      }
    `}

  &:hover {
    ${Popover} {
      display: flex;
    }
  }
`;

export const CopyIcon = styled(Copy)`
  position: relative;
  background: transparent;
  border: none;
  display: flex;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 50;
`;

export const GenerateButton = styled.button`
  font-weight: 600;
  text-align: center;
  color: var(--bg-white);
  margin: 15px 25px 20px;
  padding: 10px 60px;
  border-radius: 4px;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.74);
  background-image: linear-gradient(to bottom, #5486d6 0%, #3a6ab9);
  border: none;
  width: calc(100% - 50px);
  cursor: pointer;

  @media ${mediaQueries.mobile} {
    font-size: 14px;
    padding: 8px 60px;
    margin: 15px 15px 15px;
    width: calc(100% - 30px);
  }

  @media ${mediaQueries.tablet} {
    height: 50px;
    font-size: 18px;
    line-height: 30px;
  }

  &:hover {
    background-image: linear-gradient(to bottom, #5e97f2 0%, #4479d1);
  }

  &:active {
    background-image: linear-gradient(to bottom, #396ab9 0%, #3865af);
  }
`;

const commonAction = css`
  position: relative;
  display: block;
  right: inherit;
  left: inherit;
  margin-top: 5px;
  font-size: 12px;
  line-height: 15px;
  top: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--bg-white);
  text-align: center;
  animation: 0.1s ease-in-out forwards ${showCopyElement};
`;

export const ActionText = styled.div<{ isTouchDevice: boolean }>`
  @media ${mediaQueries.desktop} {
    position: absolute;
    display: flex;
    background: transparent;
    font-size: 16px;
    line-height: 30px;
    color: rgba(255, 255, 255, 0.4);
    border: none;
    right: 15px;
    top: 17px;
  }

  @media (max-width: 1024px) {
    ${commonAction};
  }

  ${(props) =>
    props.isTouchDevice &&
    css`
      @media (max-width: 1366px) and (min-width: 1024px) {
        ${commonAction}
      }
    `}
`;
